<!--
 *
 * loadingGif组件--"数据请求中"
 *
 * 使用方法：
 * <loading-gif :show-loading="showLoaddingGif"></loading-gif>
 *
 *  通过修改showLoaddingGif的true或者false 来控制loading的显示和隐藏!
 *
 -->
<template>
  <div class="loading" v-show="$store.state.LOADING">
    <img :src="loading"/>
    <p style="font-size:14px;color:#999">正在加载...</p>
  </div>
</template>
 
<script>
import loading from  '@/assets/img/svg-loader/circles.svg'
export default {
  data: function() {
    return {
      popupVisiblediy: false,
      loading:loading
    };
  },
  props: ["showLoading"]
};
</script>
 
 <style>
.loading {
    background: rgba(17,17,17,.7);
    border-radius: 5px;
    color: #fff;
    left: 50%;
    margin-left: -3.8em;
    min-height: 7.6em;
    position: fixed;
    text-align: center;
    top: 180px;
    width: 7.6em;
    z-index: 5000;
}
.loading img {
    width: 40px;
    height: 40px;
    margin: 35px 0px 5px 0px
}

.loading p{
  font-size: .875rem
}

</style>


// WEBPACK FOOTER //
// src/packages/loading/showloading.vue